import { createContext, useReducer } from 'react'
import { IUser } from '../interfaces'
import { getUserFromLocalStorage } from '../_services'

type LoginState = {
  loggedIn: boolean
  data?: IUser
}

const userData = getUserFromLocalStorage()

const initialState: LoginState = userData
  ? { loggedIn: true, data: userData }
  : {
      loggedIn: false
    }

const store = createContext<{
  state: LoginState
  dispatch: React.Dispatch<any>
}>({ state: initialState, dispatch: () => null })
const Provider = store.Provider

const LoginProvider: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  const [state, dispatch] = useReducer((state: LoginState, action: any) => {
    switch (action.type) {
      case 'LOGIN':
        if (action.payload){
          return { loggedIn: true, data: action.payload }
        }
        return state
      case 'LOGOUT':
        return { loggedIn: false }
      default:
        return state
    }
  }, initialState)

  return <Provider value={{ state, dispatch }}>{children}</Provider>
}

export { store, LoginProvider }
